import { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Form,
} from "react-bootstrap";
import axios from "axios";
import WindowedSelect from "react-windowed-select";
import { ErrorMessage } from "formik";
import InputFields from "../../shared/utilities/InputFields";
import states from "../../shared/data/States";

export default function LocationSection(props) {
  const [data, setData] = useState([]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "solid red 1px",
    }),
  };

  const getData = async () => {
    await axios.get("api/v1/hwts/tempid/naics").then((res) => {
      setData(res.data);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Card className="tempid-card">
      <Card.Header>
        <i className="fa fa-align-justify"></i>
        <strong>Generator and Site Location</strong>
        <div className="card-header-actions"></div>
      </Card.Header>
      <Card.Body>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="facilityName"
            config={{
              label: "Generator Name",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "12",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="facilityFEIN"
            config={{
              label: "FEIN",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "6",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="facilityBOENumber"
            config={{
              label: "BOE Number",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "6",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1">
          <Col xs="12">
            <Form.Group controlId={`formikValidation-facilityNaics`}>
              <Form.Label>NAICS Codes</Form.Label>
              <WindowedSelect
                options={data}
                isMulti={true}
                value={props.values.facilityNaics}
                onChange={(e) => {
                  if (e) {
                    props.setFieldValue("facilityNaics", e);
                  }
                }}
                styles={props.errors.facilityNaics ? customStyles : ""}
                isDisabled={props.readOnly}
              />
              <ErrorMessage name="facilityNaics">
                {(msg) => <div className="field-error">{msg.toString()}</div>}
              </ErrorMessage>
            </Form.Group>
          </Col>
        </Row>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="locationStreet1"
            config={{
              label: "Street",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "12"
            }}
            values={props.values}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="locationStreet2"
            config={{
              label: "Street2",
              placeholder: "",
              type: "text",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="locationCity"
            config={{
              label: "City",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="locationState"
            config={{
              label: "State",
              placeholder: "",
              type: "select2",
              data: states,
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={true}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="locationZip"
            config={{
              label: "Zip",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
      </Card.Body>
    </Card>
  );
}
